import { configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { api } from './commonApi';
import { reducer as authReducer } from './auth/authSlice';

const authPersistConfig = {
	key: 'auth',
	storage,
	whitelist: ['selectedRestaurantId'],
};

export const store = configureStore({
	reducer: combineReducers({
		[api.reducerPath]: api.reducer,
		auth: persistReducer(authPersistConfig, authReducer),
	}),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false }) // TODO need to enable serializable check after fixing some bad actions that use unserializable objects
			.concat(api.middleware),
	devTools: true,
});
